import { useMutation, useQueryClient } from "@tanstack/react-query";
import SellerDistributionParamsService from "../../services/SdrApi/sellerDistributionParamsService";
import { usePopup } from "../usePopup";
import { AxiosError } from "axios";
import { SdrBasedErrors } from "../../utils/Api/responses/responses";

const sellerDistributionParamsService = new SellerDistributionParamsService();

const useAlterSellerDistributionParams = () => {
    const queryClient = useQueryClient();
    const { addPopup } = usePopup();
    return useMutation(
        sellerDistributionParamsService.putSellerDistributionParams,
        {
            onSuccess: () => {
                queryClient.invalidateQueries({
                    queryKey: ["seller-distribution-params"],
                });
                addPopup({
                    title: "Parametros do(s) hunter(s) alterados.",
                    type: "success",
                    duration: "temporary",
                });
            },
            onError: (error: AxiosError<SdrBasedErrors>) => {
                addPopup({
                    title: "Erro ao alterar parametros do(s) hunter(s).",
                    description: error.response?.data.error,
                    type: "error",
                    duration: "temporary",
                });
            },
        }
    );
};
export default useAlterSellerDistributionParams;
